if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          this.cartNotification.renderContents(response);
          
          if (window.location.pathname) {
            document.querySelector('.cart-notification-product .product-price').innerText =
              Shopify.formatMoney(response.price);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });

  function fetchConfig(type = 'json') {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
    };
  }
}

// ✅ Variant switch and price update logic for size radio buttons
document.querySelectorAll('input[type="radio"][name="Size"]').forEach((radio) => {
  radio.addEventListener('change', function () {
    const selectedValue = this.value;

    // Ensure productVariants is defined and valid
    if (!window.productVariants || !Array.isArray(window.productVariants)) {
      console.error('productVariants is not defined or not an array');
      return;
    }

    // Match the variant where option1 (Size) equals selected radio value
    const variant = window.productVariants.find(v => v.option1 === selectedValue);

    if (variant) {
      // Update hidden input
      const idInput = document.querySelector('input[name="id"]');
      if (idInput) idInput.value = variant.id;

      // Format the price correctly using Shopify helper
      const formattedPrice = Shopify.formatMoney
        ? Shopify.formatMoney(variant.price, Shopify.money_format || "{{amount}}")
        : `{(variant.price / 100).toFixed(2)}`;

      // Update all price display fields
      document.querySelectorAll('.price-item--regular').forEach(label => {
        label.innerText = formattedPrice;
      });

      // Optionally update sticky bar price text if used
      document.querySelectorAll('.product-form__buttons span:nth-of-type(2), .product-sticky-bar span:nth-of-type(2)')
        .forEach(priceSpan => {
          priceSpan.innerText = formattedPrice;
        });
    } else {
      console.warn(`No matching variant found for selected size: {selectedValue}`);
    }
  });
});



